{% block sw_cms_element_jga_revocation_button %}
<div class="sw-cms-el-jga-revocation-button" style="text-align: center; padding: 20px;">
    <button
        :class="'btn btn-' + element.config.buttonStyle.value + (element.config.buttonSize.value ? ' btn-' + element.config.buttonSize.value : '')"
        disabled
    >
        {{ element.config.buttonText.value }}
    </button>
</div>
{% endblock %}
